const normalizeValue = value => decodeURI(value.toString()).toLowerCase();

export const equals = (rawValue, value) => {
  value = value ? normalizeValue(value) : value;
  rawValue = rawValue ? normalizeValue(rawValue) : rawValue;
  return rawValue === value || (rawValue !== null && rawValue === value);
};

export const getSelectedOption = filter => {
  return filter.options.find(option => {
    let optionValue=option.value;
    let filterSelectedValue=filter.selectedValue;

    // if option value includes %20  this replaces all of them  with - ex: E-TRON DT => E-TRON-DT
    if (option && option.value && (typeof option.value === 'string' || option.value instanceof String)) {
        optionValue = option.value.replaceAll('%20',"-").replaceAll(' ',"-");
    }

    // if filter value includes %20  this replaces all of them  with - ex: E-TRON DT => E-TRON-DT
    if (filter && filter.selectedValue && (typeof filter.selectedValue === 'string' || filter.selectedValue instanceof String)) {
      filterSelectedValue =  filter.selectedValue.replaceAll('%20',"-").replaceAll(' ',"-");
    }
    return equals(optionValue, filterSelectedValue)
  }) || null;
};

export const getSelectionText = filter => {
  const selectedOption = getSelectedOption(filter);
  return selectedOption && selectedOption.label;
};
